import { useNavigate, useParams } from 'react-router-dom'
import { useResetTradeBuilder } from 'state/store'

import {
  LeftSideBar,
  Navigation,
  Space,
  Typography,
  UserMenuTopBar
} from '../../components/core-v2'
import Icon from '../../components/core-v2/atoms/Icon'
import LinkIcon from '../../components/core-v2/molecules/linkIcon'
import { PATH } from '../../const'
import { useUser } from '../../utilities/hooks/useUser'
import { useAppSelector } from '../tradebuilder-v2/store/hooks'
import { getUserDisplayInfo } from '../tradebuilder-v2/util/user'
import { TradeClosePage } from './modules/pages/trade-close-page'

type HeaderProps = {
  closeAll: boolean
}

function Header({ closeAll }: HeaderProps) {
  const builderState = useAppSelector(state => state.builder)
  const navigate = useNavigate()
  return (
    <Space isflex alignItems="center" flexDirection="row">
      {closeAll && (
        <Space fontSize="15px" fontWeight="700" mr={5}>
          <Typography variant="sh3">
            Close all trades in {builderState.selectedAccount?.noteName}
          </Typography>
        </Space>
      )}
      {!closeAll && (
        <Space fontSize="15px" fontWeight="700" mr={5}>
          <Typography variant="sh3">Close {builderState.selectedAccount?.accountName}</Typography>
        </Space>
      )}
      <LinkIcon
        data-testid="back-to-new-trades-button"
        disabled={false}
        icon={<Icon name="chevronLeft" size="small" />}
        iconPosition="left"
        text="Back to the trade list"
        onClick={() => navigate(PATH.reportsOverview)}
      />
    </Space>
  )
}

export function TradeClose({ closeAll = false }: { closeAll?: boolean }) {
  const { accountId } = useParams()
  const { data: user } = useUser()
  const userInfo = getUserDisplayInfo(user)
  useResetTradeBuilder()

  return (
    <LeftSideBar
      leftElement={<Navigation />}
      mainElement={
        <>
          <Header closeAll={closeAll} />
          {accountId && (
            <TradeClosePage accountId={accountId} closeAll={closeAll} userInfo={userInfo} />
          )}
        </>
      }
      topBarElement={<UserMenuTopBar />}
    />
  )
}
